import { defineComponent as _defineComponent } from 'vue'
import {
  PropType, ref, watch
} from 'vue';
import { User } from '@/models/User';
import BCXPopup from '@/components/molecules/BCXPopup.vue';
import BCLoadingAnimation from '@/components/molecules/BCLoadingAnimation.vue';
import BCXMessengerUserSelectItem from '@/components/messenger/User/BCXMessengerUserSelectItem.vue';
import useQuickInfo from '@/state/quickInfo';
import {
  loadProjectViewers,
  sortProjectViewers,
} from '@/views/project-forum/components/viewers/projectViewers';

type ViewerState = 'loading' | 'list' | 'empty' | 'error';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectViewersPopup',
  props: {
  isOpen: Boolean,
  projectId: {
    type: String as PropType<string>,
    required: true,
  },
},
  emits: ["update:is-open"],
  setup(__props) {

const props = __props;





const { showQuickInfo } = useQuickInfo();
const users = ref<User[]>([]);
const viewerCount = ref(0);
const state = ref<ViewerState>('loading');
let requestNumber = 0;

const load = async () => {
  const currentRequest = ++requestNumber;
  users.value = [];
  viewerCount.value = 0;
  state.value = 'loading';

  try {
    const result = await loadProjectViewers(props.projectId);
    if (currentRequest !== requestNumber) return;

    viewerCount.value = result.requestedUserCount;
    users.value = sortProjectViewers(result.users);
    if (result.users.length > 0) {
      state.value = 'list';
    } else if (result.requestedUserCount === 0) {
      state.value = 'empty';
    } else {
      state.value = 'error';
    }
  } catch (_error) {
    if (currentRequest !== requestNumber) return;
    state.value = 'error';
  }
};

watch(() => props.isOpen, (isOpen) => {
  if (isOpen) load();
});

const openQuickInfo = (event: MouseEvent, user: User) => {
  const row = event.currentTarget as HTMLElement;
  showQuickInfo(row.firstElementChild as HTMLElement, user);
};

return { __sfc: true,props, showQuickInfo, users, viewerCount, state, requestNumber, load, openQuickInfo, BCXPopup, BCLoadingAnimation, BCXMessengerUserSelectItem }
}

})